export const CheckBoxChecked = {
  yes: 'yes',
  no: 'no'
};

export const DEFAULT_FORMFIELD_TWIIST = {
  totalDailyUseOfInsulin: '',
  totalDailyDose: '',

  basalRates: '',
  carbRatios: '',
  insulinSensitivity: '',

  correctionRangeA: '100',
  correctionRangeB: '115',

  glucoseSafetyLimit: '75',

  preMealPresetRangeA: '80',
  preMealPresetRangeB: '100',

  workoutPresetRangeA: '150',
  workoutPresetRangeB: '170',

  maximumBasalRate: '',
  maximumBolusRate: '10',

  'checkbox-pump-initiation': CheckBoxChecked.yes, // 'yes' or 'no'
  'u-100-novolog': true,
  'checkbox-authorize-twiist-trainer': false,

  lowerPreMealGlucose: '80',
  higherPreMealGlucose: '130',

  lowerPostMealGlucose: '80',
  higherPostMealGlucose: '180',
};

export const QID_TotalDailyUseofInsulinInput = 'QID_TotalDailyUseofInsulinInput';
